import React, {useState} from 'react'
import {Layout, LayoutChild} from "../../../../palette/Palette";
import {Button} from "devextreme-react/button";
import List from 'devextreme-react/list';
import ArrayStore from "devextreme/data/array_store";
import {NumberBox} from 'devextreme-react/number-box';
import {duplicateArrayObjects, UpdateArray} from "../../../../utils/HelpFunctions";
import Alerts from "../../../../palette/Alerts";
import axios from "axios";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {useSnackbar} from "notistack";
import Text from "../../../../palette/Text";
import {LoadIndicator} from "devextreme-react/load-indicator";
import VerticalSpace from "../../../../palette/VerticalSpace";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://save-order-easi4xatjq-uc.a.run.app/save-order';

//const url = 'http://127.0.0.1:5000/save-order';


function OrderDetail(props) {
    const {
        schedulesDriver, setPopupVisible, setSchedulesDriver, companyName, idCompany, setTrigger, trigger
    } = props

    const [load, setLoad] = useState(false)
    const [duplicates, setDuplicates] = useState(false)
    const [textValidate, setTextValidate] = useState('Guardar')
    const [success, setSuccess] = useState(false)

    const dataSource = new ArrayStore({
        key: 'ID',
        data: schedulesDriver,
    });

    const {enqueueSnackbar} = useSnackbar();

    const renderList = (data) => {

        const valueChanged = (value, key) => {
            const upDateDriver = UpdateArray([...schedulesDriver], 'driverId', key, 'order', value)
            const duplicates = duplicateArrayObjects(upDateDriver, 'order')
            setDuplicates(duplicates)
            setSchedulesDriver(upDateDriver)
        }

        return (
            <Layout color={'transparent'} row center space>
                <LayoutChild color={'transparent'}>
                    <Text hover={false} size={13} weight={700} text={data.names}/>
                    <LayoutChild color={'transparent'} center row>
                        <Text hover={false} size={10} weight={500} text={`Ruta : ${data.routeName}`}/>
                        <Text left={7} hover={false} size={10} weight={500} text={`Hora : ${data.hour}`}/>
                    </LayoutChild>
                </LayoutChild>
                <LayoutChild color={'transparent'}>
                    <NumberBox
                        width={50}
                        value={data.order}
                        onValueChanged={(e) => valueChanged(e.value, data.driverId)}
                    />
                </LayoutChild>
            </Layout>
        )
    }

    const onSaveOrder = async () => {
        if (!duplicates) {

            const data = {companyName, idCompany, schedulesDriver}

            setTextValidate('Guardando...')
            setLoad(true)

            await axios.post(url, data, {headers: headers})
                .then(res => {
                    if (res.data.status === 'OK') {
                        setSuccess(true)
                        setTextValidate('Guardar')
                        setTimeout(() => {
                            setSuccess(false)
                            setPopupVisible(false)
                            setLoad(false)
                            setTrigger(!trigger)
                        }, 1000)
                    }
                }).catch(() => {
                    setTextValidate('Guardar')
                    setTrigger(!trigger)
                    setPopupVisible(false)
                    setLoad(false)
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                })
        }
    }

    return (
        <Layout color={'#fff'}>
            <List
                dataSource={dataSource}
                itemRender={renderList}
            />
            <div style={{height: 5}}/>
            <Layout color="transparent" row center space>
                <Button
                    width={100}
                    height={30}
                    type="normal"
                    stylingMode="outlined"
                    disabled={load}
                    onClick={() => {
                        setLoad(false)
                        setPopupVisible(false)
                    }}
                >
                    <i className="far fa-arrow-alt-circle-left" style={{fontSize: '14px'}}/>
                    <span style={{fontSize: '12px', fontWeight: 'bold', marginLeft: 5}}>Salir</span>

                </Button>
                <Button
                    width={'auto'}
                    height={30}
                    type="success"
                    disabled={load}
                    stylingMode="contained"
                    onClick={onSaveOrder}
                >
                    <Layout color="transparent" center row>
                        {load && <LoadIndicator id="small-indicator" height={15} width={15}/>}
                        {!load && <i className="far fa-check-circle" style={{fontSize: '14px'}}/>}
                        <span style={{fontSize: '12px', fontWeight: 'bold', marginLeft: 7}}>{textValidate}</span>
                    </Layout>
                </Button>
            </Layout>
            {duplicates && <div style={{marginTop: 7}}/>}
            {duplicates && <Alerts severity={'error'} body={'El orden no puede repetirse'}/>}
            <VerticalSpace space={7}/>
            {success && <Alerts severity={'success'} body={'Orden asignado exitosamente'}/>}
        </Layout>
    )
}

export default OrderDetail